import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/_app.css";
import App from "./App";

const MINUTE = 1000 * 60;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 20 * MINUTE,
      retry: 2, // количество попыток при ошибке
      // Обновляем данные ТОЛЬКО при перезагрузке страницы:
      refetchOnWindowFocus: false, // не обновлять при фокусе окна
      refetchOnReconnect: false, // не обновлять при восстановлении сети
      refetchOnMount: false, // не обновлять при монтировании (если данные уже в кеше)
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
